import { type AvatarGroupProps } from '@atlaskit/avatar-group';
import { type GlobalShortcutsItem } from '@atlassian/global-shortcuts';

export type CrossJoinSourceProduct =
	| 'confluence'
	| 'jira-software'
	| 'jira-product-discovery'
	| 'jira-core'
	| 'jira-servicedesk'
	| 'jira-customer-service';

export type CrossJoinTargetProduct =
	| 'jira-software'
	| 'jira-product-discovery'
	| 'confluence'
	| 'loom';

export type CrossJoinIntegration =
	| 'crossJoinNudgesV3'
	| 'crossJoinNudgesConfluenceToJpd'
	| 'crossJoinNudgesJiraToConfluence'
	| 'crossJoinNudgesJiraToJpd'
	| 'crossJoinNudgesConfluenceToJpdMsr'
	| 'crossJoinNudgesConfluenceToJiraMsr'
	| 'crossJoinNudgesConfluenceToLoom'
	| 'invitedAppShortcuts';

/**
 * @deprecated Use CrossJoinIntegration instead. This was a typo and will be removed in a future version.
 */
export type CrossJoinIntegraton = CrossJoinIntegration;

export type Collaborator = {
	avatar: string;
	id: string;
	name: string;
};

export type Collaborators = Collaborator[];

// manage the allowed apps and their keys
export const INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS = ['jira', 'confluence'] as const;
export type InvitedAppShortcutAllowedTargetAppKey =
	(typeof INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS)[number];
export const INVITED_APP_SHORTCUTS_ALLOWED_SOURCE_APPS = ['confluence', 'jira', 'home'] as const;
export type InvitedAppShortcutAllowedSourceAppKey =
	(typeof INVITED_APP_SHORTCUTS_ALLOWED_SOURCE_APPS)[number];
export const INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS = ['JIRA_SOFTWARE', 'CONFLUENCE'] as const;
export type InvitedAppShortcutAllowedApsKey =
	(typeof INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS)[number];

export type ShortcutItemsConfig = Partial<
	Record<InvitedAppShortcutAllowedTargetAppKey, GlobalShortcutsItem>
>;

export type InvitedAppShortcutCollaborator = Pick<
	AvatarGroupProps['data'][number],
	'name' | 'src' | 'key'
>;
